/*global EaseScroll, lazyload*/

'use strict';

import { on, off, throttle, isInViewport, stopHtmlScrolling } from './modules/_fn';

/* ---------------------------------------- [START] IE Global Setting */
// 舊IE提醒
const userAgent = window.navigator.userAgent;
if (
	userAgent.indexOf('MSIE 7.0') > 0 ||
	userAgent.indexOf('MSIE 8.0') > 0 ||
	userAgent.indexOf('MSIE 9.0') > 0 ||
	userAgent.indexOf('MSIE 10.0') > 0 ||
	!!userAgent.match(/Trident.*rv\:11\./) // IE11
) {
	location.href = 'browser.html';
}

/* 防止IE沒有 JS element.remove() */
/* Create Element.remove() function if not exist */
if (!('remove' in Element.prototype)) {
	Element.prototype.remove = function () {
		if (this.parentNode) {
			this.parentNode.removeChild(this);
		}
	};
}

/* ---------------------------------------- [END] IE Global Setting */
(function (window, document) {

	on(window, 'load', function () {
		// Start
		$(document).foundation();
		// $('body').addClass('is-loaded');
	});

	/* ---------------------------------------- [START] Windows Setting */
	const html = document.documentElement;
	let ww = window.innerWidth;
	let wh = window.innerHeight;
	let ws = 0;
	function getScrollTop(target = window) {
		return (target.pageYOffset || html.scrollTop) - (html.clientTop || 0);
	}
	function getWinSet() {
		ww = window.innerWidth;
		wh = window.innerHeight;
		ws = getScrollTop();
	}
	function foundationReset() {
		if ($('.sticky')) $('.sticky').foundation('_calc', true);
	}
	on(window, 'load', getWinSet);
	on(window, 'resize', function () {
		getWinSet();
		throttle(foundationReset, 50, 100);
	});
	on(window, 'scroll', function () {
		throttle(foundationReset, 50, 100);
	});
	/* ---------------------------------------- [END] Windows Setting */

	/* ---------------------------------------- [START] 取得裝置判斷 */
	// 取得裝置判斷
	let isMobile = false;
	let isTablet = false;
	let isPhone = false;

	const deviceDetect = function () {
		// IsPhone
		isPhone = ww <= 640;

		// IsMobile
		// 防止測試時一直用開發者工具Resize出現Bug
		isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		if (isMobile) html.classList.add('is-mobile');
		else html.classList.remove('is-mobile');

		// IsTablet
		if (navigator.userAgent.match(/Android/i)) {
			if (!navigator.userAgent.match(/Mobile/i)) {
				isTablet = true;
			}
		} else if (navigator.userAgent.match(/BlackBerry|iPad|Opera Mini|IEMobile/i)) {
			isTablet = true;
		}
	};

	deviceDetect();
	on(window, 'resize', throttle(deviceDetect, 50, 100));
	/* ---------------------------------------- [END] 取得裝置判斷 */

	/* ---------------------------------------- [START] 判斷browser */
	var ua = navigator.userAgent;
	var browser = {
		isChrome: /chrome/i.test(ua),
		isFirefox: /firefox/i.test(ua),
		isSafari: /safari/i.test(ua),
		isIE: /msie/i.test(ua) || /trident/i.test(ua),
		isEdge: /edge/i.test(ua),
	};

	// 修正數值browser
	if (browser.isChrome) browser.isSafari = false;
	if (browser.isEdge) {
		browser.isChrome = false;
		browser.isSafari = false;
	}

	var browserIs;
	for (var key in browser) {
		if (browser[key]) {
			browserIs = key.split('is')[1];
			// 增加Class
			document.documentElement.classList.add(browserIs.toLowerCase());
			document.documentElement.browser = browserIs;
			break;
		}
	}
	browser.is = browserIs;

	// ----------------------------
	// 判斷 裝置
	// iOS
	var isiOS = ua.toLowerCase().match(/(iphone|ipod|ipad)/);
	isiOS && html.classList.add('ios');
	/* ---------------------------------------- [END] 判斷browser */

	/* ----------------------------------- [START] Loader 移除 */
	var loaderRemove = function () {
		var loader = document.querySelector('#loader');

		if (loader) {
			setTimeout(function () {
				loader.classList.add('loading');
			}, 50);

			setTimeout(function () {
				loader.classList.add('loaded');
			}, 1400);

			setTimeout(function () {
				loader.remove();
			}, 2100);
		}
	};
	window.addEventListener('load', loaderRemove);
	/* ----------------------------------- [END] Loader 移除 */

	/* ---------------------------------------- [START] Ease scroll */
	var buildEaseScroll = function () {
		if (window.EaseScroll === undefined) return false;
		const es = new EaseScroll({
			frameRate: 60,
			animationTime: 1000,
			stepSize: 100,
			pulseAlgorithm: 1,
			pulseScale: 6,
			pulseNormalize: 1,
			accelerationDelta: 20,
			accelerationMax: 1,
			keyboardSupport: true,
			arrowScroll: 30,
			touchpadSupport: true,
			fixedBackground: true,
			// disabledClass: 'modal-open',

			/* Browser Setting Control */
			browser: {
				Chrome: true,
				FireFox: false,
				Safari: true,
				IE: true,
				Edge: true,
			},
		});
	};
	// on(window, 'load', buildEaseScroll);
	/* ---------------------------------------- [END] Ease scroll */

	/* ---------------------------------------- [START] ScrollTriggerAni */
	// 有滑動到該區增加動態者增加class "js-ani" ， 滑動到該區增加class "is-animated"
	let aniSec = document.querySelectorAll('.js-ani');
	const scrollTriggerAniThrottle = throttle(scrollTriggerAni, 200, 500); // 節流作用

	function scrollTriggerAni() {
		for (var i = 0; i < aniSec.length; i++) {
			if (isInViewport(aniSec[i])) {
				aniSec[i].classList.add('is-animated');
			}
		}

		cleanTrigger();

		/* If load all of the item, stop Listener */
		if (aniSec.length === 0) {
			window.addEventListener('scroll', scrollTriggerAniThrottle);
		}
	}

	function cleanTrigger() {
		aniSec = Array.prototype.filter.call(aniSec, function (ani) {
			return !ani.classList.contains('is-animated');
		});
	}

	function isInViewport(el) {
		const rect = el.getBoundingClientRect();
		const isVisible = el.offsetHeight !== 0;

		return (
			isVisible &&
			rect.bottom >= 0 &&
			rect.right >= 0 &&
			rect.top + 100 <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.left <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}

	on(window, 'load', scrollTriggerAni);
	on(window, 'scroll', scrollTriggerAniThrottle);
	/* ---------------------------------------- [END] ScrollTriggerAni */

	/* ---------------------------------------- [START] Lazyload */
	/*
	 * 使用：https://github.com/verlok/vanilla-lazyload
	 * 尋找頁面上的 .lazy 為執行 Lazy Load 物件
	 */
	var lazyloadTimer = 0;
	function buildLazyLoad() {
		if (lazyloadTimer < 5 && window.LazyLoad === undefined) {
			return setTimeout(function () {
				lazyloadTimer++;
				buildLazyLoad();
			}, 500);
		}

		var lazyLoadInstance = new LazyLoad({
			// Your custom settings go here
		});
	}
	on(window, 'load', buildLazyLoad);
	/* ---------------------------------------- [END] Lazyload */

	/* ---------------------------------------- [START] 選單下滑更改樣式 */
	const doc = document.documentElement;
	const header = document.querySelector('#hd');
	const footer = document.querySelector('#ft');
	const headerClassScroll = 'is-collapse';
	function headerScrollHandler() {
		const windowScrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
		if (windowScrollTop > 0) {
			header.classList.add(headerClassScroll);
		} else {
			header.classList.remove(headerClassScroll);
		}

		if (windowScrollTop >= 50 && windowScrollTop + wh <= footer.offsetTop) {
			$('.js-fixd-service').addClass('is-show');
		} else {
			$('.js-fixd-service').removeClass('is-show');
		}
	}
	on(window, 'scroll', headerScrollHandler);
	on(window, 'load', headerScrollHandler);
	/* ---------------------------------------- [END] 選單下滑更改樣式 */

	/* ---------------------------------------- [START] --vh */
	function mobileFullHeight() {
		var isIE = $("html").hasClass("ie");
		if (!isIE) {
			// 取得視窗高度，再乘以1%得到1vh的值
			var vh = window.innerHeight * 0.01;
			var vw = window.innerWidth * 0.01;
			// 把--vh的值設置到文件的根元素中
			document.documentElement.style.setProperty("--vh", vh + "px");
			document.documentElement.style.setProperty("--vw", vw + "px");
		}
	}

	on(window, 'load', mobileFullHeight);
	on(window, 'resize', mobileFullHeight);
	/* ---------------------------------------- [END] --vh */


	/* ---------------------------------------- [START] header選單 */
	function checkIsPc() {
		if (ww > 1024) {
			// stopHtmlScrolling(false);

			$('#hd').removeClass('is-open');
			$('.js-hd-main').parent().removeClass('is-active');
		}
	}

	on(window, 'resize', checkIsPc);

	function stopHtmlScrolling(boolean) {
		if (boolean) {
			document.querySelector('html').classList.add('stop_scrolling');
		} else {
			document.querySelector('html').classList.remove('stop_scrolling');
		}
	}

	// 漢堡選單
	$(document).on('click', '.js-toggle-hamburger', function () {
		if ($('#hd').hasClass('is-open')) {
			$('#hd').removeClass('is-open');
			// stopHtmlScrolling(false);

			$('.hd_main_block').scrollTop(0);

			if ($('.js-hd-main')) {
				$('.js-hd-main').parent().removeClass('is-active');
			}
		} else {
			$('#hd').addClass('is-open');
			// stopHtmlScrolling(true);
		}
	});

	// main選單手機版
	$(document).on('click', '.js-hd-main', function () {
		const $el = $(this).parent();

		if (ww < 1024) {
			if ($el.hasClass('is-active')) {
				$el.removeClass('is-active');
			} else {
				$el.addClass('is-active');
			}
		}
	});

	// user選單手機版
	$(document).on('click', '.js-hd-user', function () {
		const $el = $(this).parent();

		if (ww < 1024) {
			if ($el.hasClass('is-active')) {
				$el.removeClass('is-active');
			} else {
				$el.addClass('is-active');
			}
		}
	});

	// user選單手機版
	$(document).on('click', '.js-hd-overlay', function () {
		if (ww < 1024) {
			if ($('#hd').hasClass('is-open')) {
				$('#hd').removeClass('is-open');
				// stopHtmlScrolling(false);
			}
		}
	});
	/* ---------------------------------------- [END] header選單 */

	/* ---------------------------------------- [START] 示意開啟 modal */
	let openModalId = '';

	window.cusOpenModal = function openModal(id) {
		setTimeout(function () {
			openModalId = id;
			$('#' + openModalId).addClass('is-active');
		}, 300);
	}

	window.cusCloseModal = function closeModal(id) {
		$('#' + id).removeClass('is-active');
		$('#' + id).removeAttr('data-href-record');
		openModalId = '';
	}

	$(document).on('click', '[data-modal-open]', function () {
		openModalId = $(this).attr('data-modal-open');
		const hrefRenew = $(this).attr('data-href-record');
		cusOpenModal(openModalId);
		// stopHtmlScrolling(true);

		if (typeof hrefRenew !== typeof undefined && hrefRenew !== false) {
			$('#' + openModalId).attr('data-href-record', hrefRenew)
		}

		if ($('[data-modal-open]').parents('.hd_user_nav_item.is-active').length) {
			$('[data-modal-open]').parents('.hd_user_nav_item.is-active').removeClass('is-active');
		}
	});

	// 示意關閉 modal
	// ios safari 12.5.5 需要加上 touchstart 事件才吃得到
	$(document).on('touchstart click', '[data-modal-close]', function () {
		if (openModalId.length) {
			cusCloseModal(openModalId);
		}
		// stopHtmlScrolling(false);

		$(this).parents('.modal.is-active').removeAttr('data-href-record').removeClass('is-active');

		if ($('#video-popup').length) {
			$('#video-popup').find('iframe').remove();
		}
	});

	// [data-test-close] 僅用在測試站
	$(document).on('touchstart click', '[data-test-close]', function () {
		$(this).parents('.modal.is-active').removeAttr('data-href-record').removeClass('is-active');
	});
	/* ---------------------------------------- [END] 示意開啟 modal */

	/* ---------------------------------------- [START] 影片彈窗 */

	var videoBox = $('.video-box');
	var youTubeSetting = '';

	var videoIframe = null;

	var buildVideoBox = function () {
		if (videoBox.length === 0) return false;

		var videoPopup = $('#video-popup');
		var videoPopupPlayer = videoPopup.find('.video-player');

		videoBox.each(function () {
			var currentItem = $(this);
			var youTubeUrl = currentItem.data('video');
			var youTubeId = getYoutubeId(youTubeUrl);

			// 寫入Properties
			this.videoId = youTubeId;

			var videoImg = currentItem.find('.video-box__preview');
			var videoPlayPopup = currentItem.find('[data-video-popup]');

			var videoIframeSrc = 'https://www.youtube.com/embed/' + youTubeId + youTubeSetting;

			var youTubeIframeString =
				'<iframe width="1080" height="608" class="video-player" src="' +
				videoIframeSrc +
				'" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';

			// Video Cover
			var videoCoverData = currentItem.data('cover');
			var videoCover =
				videoCoverData !== undefined ? videoCoverData : 'https://img.youtube.com/vi/' + youTubeId + '/0.jpg';

			if (videoImg.hasClass('lazy')) {
				// 有LazyLoad
				videoImg.attr('data-background', videoCover);
				if (videoImg.parents('.swiper-slide') !== undefined) {
					// 有Swiper的情況
					videoImg.addClass('swiper-lazy');
				} else {
					// 一般情況
					if (document.body.setLazy !== undefined) document.body.setLazy();
				}
			} else {
				// 沒有Lazy
				videoImg.css({
					'background-image': 'url(' + videoCover + ')'
				});
			}

			// Click and load iframe
			videoPlayPopup.on('click', function () {
				videoPopupPlayer.append(youTubeIframeString);
			});
		});
		// ---------------------------------------------------------------
	};

	// Start
	window.addEventListener('load', buildVideoBox);

	// 讀取網址
	// get-youtube-info.js: https://gist.github.com/ramonvictor/5629626
	function getYoutubeId(url) {
		var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
		var match = url.match(regExp);
		if (match && match[7].length == 11) {
			return match[7];
		}
		return false;
	}
	/* ---------------------------------------- [END] 影片彈窗 */

	/* ---------------------------------------- [START] fixed 選單 */
	function fixedNav() {
		const hdH = $('#hd').outerHeight(),
			windowScrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0),
			ww = window.innerWidth;

		const $el = $('.js-fix-nav'),
			elH = $el.outerHeight();

		if ($el.length) {
			const $wrap = $el.parent('.fix-wrap'),
				wrapPos = $wrap.offset().top;

			const breakpoint = $el.attr('data-fix-on'),
				dir = $el.attr('data-dir');

			if (ww < breakpoint) {
				if (windowScrollTop >= wrapPos - hdH) {
					$el.addClass('is-fixed');
					$wrap.css('height', elH);
				} else {
					$el.removeClass('is-fixed');
					$wrap.attr('style', none);
				}
			}
		}
	}

	// Start
	window.addEventListener('scroll', fixedNav);
	/* ---------------------------------------- [END] fixed 選單 */


	/* ---------------------------------------- [START]  錨點滾動 */
	$(document).on('click', '.js-link-anchor', function (e) {
		e.preventDefault();

		const thisId = $(this).attr('href');
		// console.log(thisId)

		if ($(thisId).length) {
			const scrollPos = $(thisId).offset().top;
		}

	});
	/* ---------------------------------------- [END]  錨點滾動 */


	/* ---------------------------------------- [START]  reset checked */
	$(document).on('click', '.filter-reset', function (e) {
		const $wrap = $(this).parents('.form-box');
		const $els = $wrap.find('.checkbox:checked');

		$els.each(function (key, item) {
			$(item).attr('checked', false);
		})
	});

	// $(document)
	// 	.on('focus', 'input[type="date"]', function() {
	// 		$(this).addClass('hide-placeholder');
	// 	})
	// 	.on('focus', 'input[type="date"]', function() {
	// 		if (this.value === '') {
	// 			$(this).removeAttr('hide-placeholder');
	// 		}
	// 	});

	/* ---------------------------------------- [END]  reset checked */

	/* ---------------------------------------- [START] OPT checked */
	// OPT邏輯
	function inputKey() {
		var inputKeyNumber = $('.opt-input');
		var inputKeyNumberLength = inputKeyNumber.length; // 欄位數量
		var inputKeyNumberMaxLenth = parseInt(inputKeyNumber.eq(0).attr('maxlength')); // 輸入的最大字數(抓取第一個物件的maxlength)
		var numberRegex = /^([+-]?[1-9]\d*|0)$/; // Ref: https://stackoverflow.com/a/21505954

		/** 監測input輸入的內容、文字長度、轉換Focus到下一個*/
		inputKeyNumber.on('keyup', function (event) {
			var self = $(this);

			// 避免出現可用於數字計算的符號文字，如"e", "."，Ref: https://stackoverflow.com/a/4460628
			if (self.val().match(numberRegex) === null) {
				self.val(self.val().replace(numberRegex, ''));
			}

			if (self.val().length >= inputKeyNumberMaxLenth) {
				// 最多只能輸入maxlength個字
				// Ref: https://stackoverflow.com/a/8355013
				self.val(self.val().slice(0, inputKeyNumberMaxLenth));

				// Focus Next
				var currentIndex = self.index();
				if (currentIndex <= inputKeyNumberLength - 2) {
					self.next().focus();
					// inputKeyNumber.eq(currentIndex + 1).focus();
				} else if (currentIndex === inputKeyNumberLength - 1) {
					// 最後一項 => 移除Focus物件
					self.blur();
				}
			} else if (self.val().length < 1) {
				// 倒回前一個
				self.prev().focus();
			}
		});

		/** 如果有輸入值，選擇(Focus)<input>，則會全選<input>文字*/
		inputKeyNumber.on('focus', function () {
			if (this.value.length > 0) {
				// 因為type="number"沒有支援全選function(setSelectionRange)
				// 所以先換text選完再換回number
				// Ref: https://stackoverflow.com/a/40017467

				// 因為iOS切換type頁面會一直跳，所以iOS系統不做此功能
				var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
				if (!iOS) {
					this.type = 'text';
					this.setSelectionRange(0, this.value.length);
					this.type = 'number';
				}
			}
		});

		// inputKeyNumber.on('paste', function (e) {
		// 	var pasteTxt = e.originalEvent.clipboardData.getData('text');

		// 	if(numberRegex.test(pasteTxt)) {
		// 		var pasteArr = pasteTxt.split('')
		// 		console.log(inputKeyNumber[0])
		// 	}
		// });

		inputKeyNumber.each(function (index, item) {
			item.addEventListener('paste', handlePaste);
		});

		// Ref: stack overflow: https://stackoverflow.com/a/6804718/11240898
		// Ref: Demo: https://jsfiddle.net/swL8ftLs/12/
		function handlePaste(e) {
			e.stopPropagation();
			e.preventDefault();

			// 取得貼上的資料
			var clipboardData = e.clipboardData || window.clipboardData;
			var pastedData = "";
			if (window.clipboardData && window.clipboardData.getData) { // IE
				// Ref: https://stackoverflow.com/a/30126108/11240898
				pastedData = window.clipboardData.getData('Text');
			} else if (e.clipboardData && e.clipboardData.getData) {
				pastedData = e.clipboardData.getData('text/plain');
			}
			pastedData = pastedData.replace(/\D/g, ''); // 取代掉非數字文字

			// 如果為空值 => 則不運作
			if (pastedData === '') { return }

			// 將貼上的文字轉為 Array
			var pasteArray = pastedData.split('');

			// 將貼上的文字塞入input
			for (var i = 0; i < inputKeyNumber.length; i++) {
				inputKeyNumber.eq(i)[0].value = pasteArray[i] || '';
			}

			// 移除 Focus 狀態 (IE無作用)
			// 看是要貼上後 「送出」？或是 Focus 在送出按鈕，需自行客製
			e.target.blur();
		}
	};

	window.addEventListener('load', inputKey);
	/* ---------------------------------------- [END] OPT checked */

})(window, document);

/* ---------------------------------------- [START] cookie */
// data-max-age：幾天內不會出現，預設180天
(function (window, document) {
	var cookieNotice = document.querySelector('#cookie-notice');
	var cookieMaxAge; // 紀錄時效
	var setName = 'cookieNoticeHide';

	function checkCookie() {
		/* 頁面上沒有 Cookie 物件 => 不執行 */
		if (!cookieNotice) {
			return false;
		}

		var cookieNoticeBtn = cookieNotice.querySelector('button');
		// var cookieNoticeBtnClose = cookieNotice.querySelector('[data-close]');

		/* 確認是否已經有確認Cookie */
		if (getCookie(setName) === 'true') {
			/* 已有確認 */
			cookieNotice.remove();
		} else {
			/* 未確認 */
			cookieNotice.classList.add('is-show');

			/* 取得過期時間設定 */
			cookieMaxAge = cookieNotice.getAttribute('data-max-age') || 180;
			if (typeof cookieMaxAge === 'string') {
				cookieMaxAge = parseInt(cookieMaxAge);
			}
		}

		var closeHandler = function () {
			cookieNotice.classList.remove('is-show');
			setTimeout(function () {
				cookieNotice.remove();
			}, 1000);
		}

		/* 按下「確認」功能 */
		cookieNoticeBtn.addEventListener('click', function () {
			setCookie(setName, true, cookieMaxAge); // 時效設定單位：天
			closeHandler();
		});

		// /* 按下「有連結的按鈕」功能 */
		// if (cookieNoticeBtnAnchor) {
		// 	cookieNoticeBtnAnchor.addEventListener('click', function() {
		// 		closeHandler();
		// 	});
		// }

		/* 按下「關閉」功能 */
		// if (cookieNoticeBtnClose) {
		// 	cookieNoticeBtnClose.addEventListener('click', function() {
		// 		closeHandler();

		// 		// 2022/07/27 客戶希望增加設定，按下叉後，永遠不顯示
		// 		localStorage.setItem('cookieClosed', true);
		// 	});
		// }
	}

	window.addEventListener('load', checkCookie);

	/* ------------------------------------------------------- Tool */
	/* https://stackoverflow.com/a/24103596/11240898 */
	function setCookie(name, value, days) {
		var expires = '';
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = '; expires=' + date.toUTCString();
		}
		document.cookie = name + '=' + (value || '') + expires + '; path=/';
	}

	function getCookie(name) {
		var nameEQ = name + '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i].trim();
			if (c.indexOf(nameEQ) === 0) {
				return c.replace(nameEQ, '');
			}
		}
		return null;
	}
	/* ------------------------------------------------------- Tool */

	/* ------------------------------------------------------- TabPos */
	function bulidMainTabsPos() {
		const $mainTabs = document.querySelectorAll('.js-tabs-pos');

		if ($mainTabs.length) {
			$mainTabs.forEach((tab) => {
				const $items = tab.querySelectorAll('.tabs-title');
				let nowScrollLeft = 0, flag = true;

				$items.forEach((item) => {
					let style = getComputedStyle(item);
					let marginLeft = parseInt(style.marginLeft);
					let marginRight = parseInt(style.marginRight);

					if (item.classList.contains('is-active')) flag = false;
					if (!flag) return;
					nowScrollLeft = nowScrollLeft + item.offsetWidth + marginLeft + marginRight;
				});

				$(tab).animate({
					scrollLeft: nowScrollLeft
				}, 500);
			});
		}
	}

	$(document).on('change.zf.tabs', '.js-tabs-pos', function() {
		bulidMainTabsPos();
	});

	on(window, 'load', bulidMainTabsPos);

	/* ------------------------------------------------------- TabPos */

})(window, document);
/* ---------------------------------------- [END] cookie */
